var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-list',
  created () {
    var readMore = false
    if (this.currentPage !== null && this.currentPage >= 1) {
      readMore = 'keepload'
    }
    utils.backClear()

    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      shopName: '',
      searchCallbackFlag: false,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'shop_name_furigana':{'state': true, 'order': true},
        'shop_address':      {'state': false, 'order': false},
        'shop_tel':          {'state': false, 'order': false}
      }
    }
  },
  /** 画面遷移時 **/
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    shops () {
      return this.$store.getters.shopList
    },
    nextPage () {
      return this.$store.getters.shopListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    currentPage () {
      return this.$store.getters.shopListCurrentPage
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    // 入社手続きタブの表示条件（onboarding-list.js の canReview と同じ判定）
    canReviewOnboarding () {
      return this.$store.getters.isAppIncluding ||
        this.$store.getters.isAppNotIncluded ||
        this.$store.getters.shopMaster ||
        this.$store.getters.clerk ||
        window.localStorage.getItem('is_human_staff') === '1' ||
        window.localStorage.getItem('user_authority') === '5' ||
        this.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.shopListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function (){
        self.searchCallbackFlag = true
      }
      var data = {'shop_name': this.shopName,
                  'order':     this.orderByString(),
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      this.$store.dispatch('SHOP_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('shop_name_furigana asc')
      }
      return result.join(' , ')
    },
    goUserLists: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goPhotoLists: function () {
      utils.backClear()
      this.$router.push({ path: '/userphotos', query: { type: this.$router.currentRoute.query.type}})
    },
    goChangeLists: function () {
      utils.backClear()
      this.$router.push({ path: '/userchanges', query: { type: this.$router.currentRoute.query.type}})
    },
    goRitireeLists: function() {
      utils.backClear()
      this.$router.push({ path: '/retiree', query: { type: this.$router.currentRoute.query.type}})
    },
    goOnboardingLists: function () {
      utils.backClear()
      this.$router.push({path: '/onboarding', query: {type: this.$router.currentRoute.query.type}})
    },
    goShopDelete: function (shopId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('SHOP_DELETE',  {id: shopId, callback: this.onSaved})
      }
    },
    onSaved: function (result) {
      this.$router.push('/shops')
    },
    goShopEdit: function (shopId) {
      this.$router.push({ path: '/shops/' + shopId + '/edit'})
    },
    goShopNew: function () {
      this.$router.push({ path: '/shops/new', query: { type: this.$router.currentRoute.query.type}})
    },
    half: function () {
      this.shopName = utils.emHalf(this.shopName)
    },
    goShopDetail: function (shopId) {
      this.$router.push({ path: '/shops/' + shopId })
    },
    telChange: function (tel) {
      return 'tel:' + tel
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-list.js